import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { ReactComponent as DocOk } from '../../../../assets/svg/doc-ok.svg';
import styles from './CalcUploadedFile.module.scss';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CalcMenuButton from '../CalcMenuButton/CalcMenuButton';

import { ReactComponent as GeneratingIco } from '../../../../assets/svg/generating.svg';
import { ReactComponent as OkSvg } from '../../../../assets/svg/ok.svg';
import { ReactComponent as ErrorSvg } from '../../../../assets/svg/doc-err.svg';
import { ReactComponent as EmptySvg } from '../../../../assets/svg/doc-empty.svg';
import Tooltip from '@mui/material/Tooltip';

import pageStyles from '../component.module.scss';

import { useSelectedContext } from 'context/contextSelector';
import { downloadFileFromURL } from '../../../../utils/appUtils';
import { IconButton } from '@mui/material';

const icoStyle = { width: 20, height: 20, flexShrink: 0, fontSize: 20, padding: 0 };
const ttRestHost = `${process.env.REACT_APP_SSO_API}/tt-documents/docs`;

const TooltipRender = ({ tooltipText, iconWidth = 20, iconHeight = 20, Icon }) => (
  <Tooltip
    slotProps={{
      tooltip: {
        sx: {
          fontFamily: 'Montserrat',
          fontSize: '12px',
          padding: '12px 20px',
          border: 'none',
          borderRadius: '12px',
          color: '#FFFFFF',
          backgroundColor: '#999999',
        },
      },
    }}
    title={tooltipText}
    placement="top"
    describeChild
  >
    <span style={{ display: 'block', width: iconWidth, height: iconHeight }}>
      <Icon style={icoStyle} />
    </span>
  </Tooltip>
);

const statuses = {
  NONE: 'NONE',
  PROCESSING: 'PROCESSING',
  NOT_EXISTS: 'NOT_EXISTS',
  NOT_READABLE: 'NOT_READABLE',
  SUCCESS: 'SUCCESS',
  NO_DATA: 'NO_DATA',
};

const getQuestionTooltip = (state) => {
  switch (state) {
    case statuses.PROCESSING:
      return 'The file is being parsed.';
    case statuses.SUCCESS:
      return 'File parsed successfully.';
    case statuses.NOT_EXISTS:
      return 'File does not exist.';
    case statuses.NOT_READABLE:
      return 'The file is damaged or cannot be opened.';
    case statuses.NO_DATA:
      return 'No data available to answer.';
    default:
      return '';
  }
};

const getQuestionIco = (state) => {
  switch (state) {
    case statuses.PROCESSING:
      return <GeneratingIco className={pageStyles.rotating} />;
    case statuses.SUCCESS:
      return <OkSvg />;
    case statuses.NOT_EXISTS:
      return <ErrorSvg />;
    case statuses.NOT_READABLE:
      return <ErrorSvg />;
    case statuses.NO_DATA:
      return <EmptySvg />;
    default:
      return <div />;
  }
};

const CalcUploadedFile = ({ file }) => {
  const { user } = useSelectedContext((context) => context.user);
  const [isDescriptionShown, setIsDescriptionShown] = useState(false);

  const downloadFile = (url) => {
    downloadFileFromURL(url, file.originalName);
  };

  const generateLink = () => {
    const token = Cookies.get('access_token');
    const headers = {
      authorization: token ? `Bearer ${token}` : '',
      Userid: user.id,
    };
    const par = `?name=${file.uuidName}`;
    const url = `${ttRestHost}/downloadUrl${par}`;

    axios
      .get(url, { headers })
      .then((response) => {
        const { data } = response;
        if (data?.success) {
          downloadFile(data.url);
        }
      })
      .catch((error) => console.log(error));
  };

  const onMenuClick = (option) => {
    if (option === 'Download') generateLink();
  };

  return (
    <div className={styles.fileContainer}>
      <div className={styles.fileRow}>
        <div className={styles.fileName} title={file.originalName}>
          <div className={styles.svg}>
            {TooltipRender({
              tooltipText: getQuestionTooltip(file?.state),
              Icon: () => getQuestionIco(file?.state),
            })}
          </div>
          <div className={styles.text}>{file.originalName}</div>
        </div>
        <div className={styles.buttons}>
          {file.description && (
            <IconButton onClick={() => setIsDescriptionShown((value) => !value)}>
              {isDescriptionShown ? (
                <ExpandLessIcon style={icoStyle} />
              ) : (
                <ExpandMoreIcon style={icoStyle} />
              )}
            </IconButton>
          )}
          <CalcMenuButton params={{ onMenuClick }} />
        </div>
      </div>
      {isDescriptionShown && <div className={styles.description}>{file.description}</div>}
    </div>
  );
};

export default CalcUploadedFile;
